<footer class="mt-3">
  <nav
    class="container-fluid navbar-light bg-white small-footer"
    aria-live="off"
  >
    <div class="row h-100">
      <div class="col-8">
        <div class="row h-100">
          <div
            class="col-lg-6 col-xs-12 d-flex justify-content-center flex-column pt-3 pt-lg-0"
            id="cvc"
          >
            {{ simulationFullName }}
          </div>
          <div
            class="col-lg-6 col-xs-12 d-lg-flex justify-content-center"
            id="powered"
          >
            <a
              href="http://megalearning.com/"
              target="_blank"
              class="d-lg-flex align-items-center"
            >
              <span id="powered-text">POWERED BY&nbsp;&nbsp;&nbsp;</span>
              <img src="img/mega-light.svg" alt="MEGA Learning" />
            </a>
          </div>
        </div>
      </div>
      <div class="col-4 d-flex justify-content-end align-items-center">
        <button
          type="button"
          class="btn btn-circle btn-xl"
          id="btn-top"
          (click)="onClick($event)"
          aria-label="Back to top"
        >
          <img src="{{ logoImage }}" alt="" aria-hidden="true" />
        </button>
      </div>
    </div>
  </nav>
</footer>
